// Mock data for WINDFALL LOGISTICS INC

export const services = [
  {
    id: 1,
    title: 'FULL TRUCKLOAD',
    description: 'Dedicated capacity for large shipments with door-to-door service',
    details: '53ft cargo vans, box trucks, reefers',
    icon: 'Truck'
  },
  {
    id: 2,
    title: 'LTL FREIGHT',
    description: 'Cost-effective partial loads with flexible scheduling',
    details: 'Palletized freight, 150-15,000 lbs',
    icon: 'Package'
  },
  {
    id: 3,
    title: 'EXPEDITED',
    description: 'Emergency delivery within 24-48 hours nationwide',
    details: 'Team drivers, hot shot service',
    icon: 'Zap'
  },
  {
    id: 4,
    title: 'INSURED CARGO',
    description: 'Full protection up to $100K per shipment',
    details: 'Cargo insurance, liability coverage',
    icon: 'Shield'
  },
  {
    id: 5,
    title: 'WHITE GLOVE',
    description: 'Premium handling for high-value or fragile items',
    details: 'Inside delivery, assembly service',
    icon: 'Star'
  },
  {
    id: 6,
    title: 'CONSULTING',
    description: 'Supply chain optimization and route planning',
    details: 'Cost analysis, efficiency reports',
    icon: 'TrendingUp'
  }
];

export const stats = [
  {
    id: 1,
    number: '50',
    label: 'STATES',
    sublabel: 'Nationwide Coverage'
  },
  {
    id: 2,
    number: '24/7',
    label: 'HOUR',
    sublabel: 'Always Available'
  },
  {
    id: 3,
    number: '15K+',
    label: 'DELIVERIES',
    sublabel: 'Monthly Volume'
  },
  {
    id: 4,
    number: '99.8%',
    label: 'ON-TIME',
    sublabel: 'Delivery Rate'
  }
];

export const features = [
  {
    id: 1,
    title: 'ON-TIME DELIVERY',
    description: '99.8% punctuality rate with GPS tracking and proactive communication',
    icon: 'Clock'
  },
  {
    id: 2,
    title: '50 STATES',
    description: 'Complete coverage including Alaska and Hawaii with local partnerships',
    icon: 'MapPin'
  },
  {
    id: 3,
    title: 'REAL-TIME TRACKING',
    description: 'Advanced GPS monitoring with automated updates and delivery confirmations',
    icon: 'Radio'
  },
  {
    id: 4,
    title: 'TRANSPARENT PRICING',
    description: 'No hidden fees, fuel surcharges included, instant online quotes available',
    icon: 'DollarSign'
  }
];

export const testimonials = [
  {
    id: 1,
    quote: 'Windfall Logistics Inc has been our go-to logistics partner for 3 years. Their reliability and customer service are unmatched. Never had a late delivery!',
    author: 'Sarah Johnson',
    company: 'Johnson Manufacturing',
    shipments: '200+ shipments'
  },
  {
    id: 2,
    quote: 'The real-time tracking and communication kept us informed every step of the way. Professional drivers and competitive pricing.',
    author: 'Mike Rodriguez',
    company: 'Tech Solutions Inc',
    shipments: '150+ shipments'
  },
  {
    id: 3,
    quote: 'From coast to coast, Windfall Logistics Inc handles our most critical shipments. Their white glove service saved us thousands in potential damages.',
    author: 'Lisa Chen',
    company: 'Global Imports LLC',
    shipments: '500+ shipments'
  }
];

export const fleet = [
  {
    id: 1,
    type: 'CARGO VANS',
    count: '150+',
    description: 'Modern cargo vans',
    features: ['Air ride suspension', 'Load bars included', 'GPS tracking'],
    icon: 'Container'
  },
  {
    id: 2,
    type: 'BOX TRUCKS',
    count: '75+',
    description: 'Heavy-duty box trucks',
    features: ['Tarps & straps', 'Conestoga available', 'Heavy haul capable'],
    icon: 'Box'
  },
  {
    id: 3,
    type: 'REEFERS',
    count: '50+',
    description: 'Temperature controlled',
    features: ['Multi-temp zones', '-20°F to +70°F', 'Backup power'],
    icon: 'Snowflake'
  },
  {
    id: 4,
    type: 'POWER UNITS',
    count: '200+',
    description: 'Late model tractors',
    features: ['Avg 2 years old', 'Fuel efficient', 'Safety certified'],
    icon: 'Truck'
  }
];

export const safety = [
  {
    id: 1,
    title: 'DOT Safety Rating',
    value: 'SATISFACTORY',
    icon: 'CheckCircle'
  },
  {
    id: 2,
    title: 'Insurance Coverage',
    value: '$1M+',
    icon: 'Shield'
  },
  {
    id: 3,
    title: 'Driver Training',
    value: '40+ Hours',
    icon: 'Award'
  },
  {
    id: 4,
    title: 'Vehicle Inspections',
    value: 'Daily',
    icon: 'Search'
  }
];

export const safetyFeatures = [
  {
    id: 1,
    title: 'DOT COMPLIANT',
    description: 'Full compliance with Department of Transportation regulations and safety standards',
    icon: 'FileCheck'
  },
  {
    id: 2,
    title: 'HAZMAT CERTIFIED',
    description: 'Licensed to transport hazardous materials with proper documentation and training',
    icon: 'AlertTriangle'
  },
  {
    id: 3,
    title: 'PREVENTIVE MAINTENANCE',
    description: 'Rigorous maintenance schedule ensures vehicle reliability and safety',
    icon: 'Wrench'
  },
  {
    id: 4,
    title: 'DRIVER SCREENING',
    description: 'Comprehensive background checks, drug testing, and ongoing safety training',
    icon: 'UserCheck'
  }
];

export const faqs = [
  {
    id: 1,
    question: 'What areas do you service?',
    answer: 'We provide freight services to all 50 states including Alaska and Hawaii. Our extensive network of partners ensures reliable delivery anywhere in the continental US.'
  },
  {
    id: 2,
    question: 'How do I track my shipment?',
    answer: "Every shipment receives a unique tracking number with real-time GPS updates. You'll receive automated notifications at key milestones and can call our dispatch team 24/7."
  },
  {
    id: 3,
    question: 'What types of freight do you handle?',
    answer: 'We handle dry goods, temperature-controlled items, oversized cargo, and hazardous materials. From small LTL shipments to full truckloads, we have the right equipment.'
  },
  {
    id: 4,
    question: 'How quickly can you pick up my freight?',
    answer: 'Standard pickups are scheduled within 24-48 hours. For expedited service, we can often arrange same-day pickup depending on location and availability.'
  },
  {
    id: 5,
    question: 'Do you provide insurance coverage?',
    answer: 'Yes, all shipments are covered up to $100,000 at no additional cost. Higher coverage limits are available for valuable cargo at competitive rates.'
  },
  {
    id: 6,
    question: 'What payment methods do you accept?',
    answer: 'We accept major credit cards, ACH transfers, and offer net payment terms for qualified businesses. Quick Pay options are available for faster processing.'
  }
];

export const contactInfo = {
  address: '4213 Pond Willow Rd, Naperville, IL US 60564',
  phone: '(404) 593-0143',
  phoneRaw: '4045930143',
  email: 'hr@windfallogistics.com'
};
